// extracted by mini-css-extract-plugin
export default {"melodyVideo":"DJ-z","isFullWidth":"EJ-z","landingPageVideo":"FJ-z","play":"GJ-z","iframeVideo":"HJ-z","playHidden":"IJ-z","fullwidth":"JJ-z"};